var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.751 7.19071L7.66728 0.103393C7.60069 0.0368099 7.51078 0 7.41661 0C7.32245 0 7.2325 0.0375401 7.16595 0.10409L0.10339 7.19071C0.00212113 7.29198 -0.0276189 7.4442 0.0269155 7.57663C0.082147 7.70904 0.211031 7.79474 0.354056 7.79474H4.24857V16.6459C4.24857 16.8414 4.40719 17 4.60263 17H10.2674C10.4628 17 10.6215 16.8414 10.6215 16.6459V7.7947H14.5011C14.6441 7.7947 14.773 7.70831 14.8282 7.5759C14.8835 7.4435 14.8523 7.29198 14.751 7.19071Z",
    fill: "#12B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.745ac56f7e6f747d3d49a2e6b2f321cc.svg";
export { ForwardRef as ReactComponent };